module.exports = __webpack_public_path__ + "img/09.d810df9e.svg";